import { useEffect, useState } from "react";
import type { ScreenRecordingClip } from "./screen-recording-store";
import { useVoiceAttentionStore } from "./voice-attention-store";

export function useScreenRecordingElapsed(clip?: ScreenRecordingClip): number {
  const [elapsed, setElapsed] = useState(0);
  const clipId = clip?.clipId;
  const phase = clip?.phase;
  const startedMs = clip?.startedMs ?? 0;
  const recordingId = useVoiceAttentionStore((state) => state.recordingId);
  const clockStartedAt = useVoiceAttentionStore(
    (state) => state.clockStartedAt,
  );
  const sessionStartedAt =
    recordingId === clip?.attentionSessionId && clockStartedAt > 0
      ? clockStartedAt
      : null;
  useEffect(() => {
    setElapsed(0);
    if (!clipId || phase !== "recording") return;
    const started =
      sessionStartedAt === null
        ? performance.now()
        : sessionStartedAt + startedMs;
    const update = () =>
      setElapsed(
        Math.max(0, Math.floor((performance.now() - started) / 1_000)),
      );
    update();
    const timer = window.setInterval(update, 250);
    return () => window.clearInterval(timer);
  }, [clipId, phase, sessionStartedAt, startedMs]);
  return elapsed;
}
